"use strict";

exports.__esModule = true;
exports.default = _default;

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("material-ui-shell/lib/providers/Menu/Context"));

var _styles = require("@material-ui/core/styles");

var _Config = require("base-shell/lib/providers/Config");

var _Online = require("base-shell/lib/providers/Online");

var _reactIntl = require("react-intl");

var _clsx = _interopRequireDefault(require("clsx"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      overflow: 'hidden'
    },
    appBar: {
      zIndex: theme.zIndex.drawer,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      maxHeight: 64
    },
    appBarShift: {
      width: function width(props) {
        return "calc(100% - " + props.width + "px)";
      },
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    menuButton: {
      marginLeft: -12
    },
    hide: {
      display: 'none'
    },
    toolbar: _extends({
      alignItems: 'center',
      justifyContent: 'flex-end'
    }, theme.mixins.toolbar),
    offlineIndicator: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.secondary.main,
      justifyContent: 'center',
      right: 0,
      left: 0,
      height: function height(props) {
        return props.offlineIndicatorHeight;
      }
    },
    content: {
      flex: 1,
      overflow: 'auto'
    },
    grow: {
      flex: '1 1 auto'
    }
  };
});

function _default(_ref) {
  var children = _ref.children,
      pageTitle = _ref.pageTitle,
      onBackClick = _ref.onBackClick,
      isLoading = _ref.isLoading,
      _ref$appBarContent = _ref.appBarContent,
      appBarContent = _ref$appBarContent === void 0 ? null : _ref$appBarContent,
      contentStyle = _ref.contentStyle,
      _ref$tabs = _ref.tabs,
      tabs = _ref$tabs === void 0 ? null : _ref$tabs;
  var isOnline = (0, _Online.useOnline)();
  var theme = (0, _styles.useTheme)();

  var _useConfig = (0, _Config.useConfig)(),
      appConfig = _useConfig.appConfig;

  var _ref2 = appConfig || {},
      menu = _ref2.menu;

  var _ref3 = menu || {},
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? 240 : _ref3$width,
      _ref3$offlineIndicato = _ref3.offlineIndicatorHeight,
      offlineIndicatorHeight = _ref3$offlineIndicato === void 0 ? 12 : _ref3$offlineIndicato;

  var _useContext = (0, _react.useContext)(_Context.default),
      toggleThis = _useContext.toggleThis,
      isDesktop = _useContext.isDesktop,
      isMenuOpen = _useContext.isMenuOpen;

  var intl = (0, _reactIntl.useIntl)();
  var headerTitle = '';

  if (typeof pageTitle === 'string' || pageTitle instanceof String) {
    headerTitle = pageTitle;
  }

  var classes = useStyles({
    width,
    offlineIndicatorHeight
  });

  var handleDrawerMenuClick = function handleDrawerMenuClick() {
    if (!isMenuOpen) {
      toggleThis('isMiniMode', false);
      toggleThis('isMenuOpen', true);

      if (!isDesktop) {
        toggleThis('isMobileMenuOpen');
      }
    } else {
      toggleThis('isMobileMenuOpen');
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: isDesktop ? 'absolute' : undefined,
    className: isDesktop ? (0, _clsx.default)(classes.appBar, isMenuOpen && classes.appBarShift) : classes.appBar
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "inherit",
    "aria-label": "open drawer",
    onClick: handleDrawerMenuClick,
    edge: "start",
    className: (0, _clsx.default)(classes.menuButton, isMenuOpen && isDesktop && classes.hide, onBackClick && classes.hide)
  }, /*#__PURE__*/_react.default.createElement(_icons.Menu, null)), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    color: "inherit",
    "aria-label": "open drawer",
    onClick: onBackClick,
    className: (0, _clsx.default)(classes.menuButton, !onBackClick && classes.hide)
  }, /*#__PURE__*/_react.default.createElement(_icons.ChevronLeft, null)), !onBackClick && isMenuOpen && false && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginRight: 32
    }
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6",
    color: "inherit",
    noWrap: true
  }, headerTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.grow
  }), appBarContent)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.toolbar
  }), isLoading && /*#__PURE__*/_react.default.createElement(_core.LinearProgress, null), !isOnline && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      height: 15,
      backgroundColor: theme.palette.secondary.main
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    color: "textSecondary",
    noWrap: true
  }, intl.formatMessage({
    id: 'offline',
    defaultMessage: 'Offline'
  }))), tabs, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content,
    style: contentStyle
  }, children));
}

module.exports = exports.default;